import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../public/assets/mlLogos/logo-white-font.png'


const _hoisted_1 = { class: "imageEditorHeader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container flex items-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "ml_icon",
    class: "logo mr-4"
  })
], -1)
const _hoisted_3 = { class: "viewerHolder" }

import { PropType, onMounted, ref } from 'vue';
import { IonHeader, IonToolbar, modalController } from '@ionic/vue';
//Models
import { instanceOfStrapiImage } from '@/models/photo/strapi-media.model';

import { getPhotoUrl } from '@/utilities/get-media-url';
import { AnnotationEditor } from '@markerjs/markerjs-ui';
import { APhoto } from '@/models/photo/a-photo.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEditor',
  props: {
    image: {
      type: Object as PropType<APhoto>,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    }
  },
  setup(__props) {

const props = __props;




// References to DOM and MarkerArea
const editorContainer = ref<HTMLDivElement | null>(null);
const editor = ref<AnnotationEditor | null>(null);

onMounted(async () => {
    await loadEditor();
});

async function loadEditor() {

    if (editorContainer.value) {
        const imgUrl = getPhotoUrl(props.image);
        if(imgUrl === undefined) {
            console.error("Image URL is undefined");
            return;
        }
        const targetImg = document.createElement('img');
        targetImg.src = imgUrl;
        targetImg.crossOrigin="anonymous";

        editor.value = new AnnotationEditor();
        editor.value.targetImage = targetImg;

        editorContainer.value.appendChild(editor.value);

        editor.value.addEventListener("editorsave", (event) => {            
            const dataUrl = event.detail.dataUrl; // dataUrl contains data: "data:image/png;base64,iVBORw0K..."

            modalController.dismiss({newImg: dataUrl, oldId: instanceOfStrapiImage(props.image) ? props.image.id : props.image.uid}, 'save');
        });

        editor.value.addEventListener("editorclose", (event) => {
            modalController.dismiss(null, 'cancel');
        });

    }    
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), {
          color: "red",
          class: _normalizeClass(["text-white flex items-end ml-background ion-no-border", { safeAreaTop: __props.isMobile }])
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        id: "imageEditor",
        class: _normalizeClass({ safeArea: __props.isMobile }),
        ref_key: "editorContainer",
        ref: editorContainer
      }, null, 2)
    ])
  ]))
}
}

})